import {Component, OnInit, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {ConfirmDialogService} from '../../../Services/confirm-dialog.service';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css'],
  standalone: false
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  message: any; // This stores the message sent by the dialog service
  private subscription: Subscription;

  constructor(private confirmDialogService: ConfirmDialogService) {
  }

  ngOnInit(): void {
    // Subscribe to dialog message updates from the ConfirmDialogService
    this.subscription = this.confirmDialogService.getMessage().subscribe((message) => {
      this.message = message; // Set the dialog's state based on the latest message
    });
  }

  ngOnDestroy(): void {
    // Cleanup: unsubscribe to avoid memory leaks
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // This method is triggered when the "Yes" button is clicked in the dialog
  onYes(): void {
    if (this.message && this.message.yesFn) {
      this.message.yesFn(); // Execute the service's logic for "Yes"
    }
  }

  // This method is triggered when the "No" button is clicked in the dialog
  onNo(): void {
    if (this.message && this.message.noFn) {
      this.message.noFn(); // Execute the service's logic for "No"
    }
  }
}
